module.exports = __webpack_public_path__ + "static/media/icon-mark-unread.e9ecebe3.svg";